module.exports = "/_next/static/images/894363c20c246daadeaf2d5d5c24a72b-cajitas-left-desktop.jpg";